import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftEmailSenderServer } from "namirasoft-email-sender";
import { NamirasoftNotificationSenderServer } from "namirasoft-notification-sender";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftSMSSenderServer } from "namirasoft-sms-sender";
import { NamirasoftTelegramSenderServer } from "namirasoft-telegram-sender";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { NotificationSenderLayout } from "./NotificationSenderLayout";
import { NotificationSenderRoutes } from "./NotificationSenderRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SendPage from "./pages/SendPage";
import SentSubscriberListPage from "./pages/SentSubscriberListPage";
import SentTopicListPage from "./pages/SentTopicListPage";
import SubscriberEditPage from "./pages/SubscriberEditPage";
import SubscriberListPage from "./pages/SubscriberListPage";
import SubscriberViewPage from "./pages/SubscriberViewPage";
import TopicEditPage from "./pages/TopicEditPage";
import TopicListPage from "./pages/TopicListPage";
import TopicViewPage from "./pages/TopicViewPage";
import VerifySubscriberPage from "./pages/VerifySubscriberPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_NOTIFICATION_SENDER = new EnvService("REACT_APP_BASE_URL_NOTIFICATION_SENDER", true).getString();
            let REACT_APP_BASE_URL_EMAIL_SENDER = new EnvService("REACT_APP_BASE_URL_EMAIL_SENDER", true).getString();
            let REACT_APP_BASE_URL_SMS_SENDER = new EnvService("REACT_APP_BASE_URL_SMS_SENDER", true).getString();
            let REACT_APP_BASE_URL_TELEGRAM_SENDER = new EnvService("REACT_APP_BASE_URL_TELEGRAM_SENDER", true).getString();

            let notification_sender = new NamirasoftNotificationSenderServer(REACT_APP_BASE_URL_NOTIFICATION_SENDER, result.account.token_manager, result.notifier.onError);
            let email_sender = new NamirasoftEmailSenderServer(REACT_APP_BASE_URL_EMAIL_SENDER, result.account.token_manager, result.notifier.onError);
            let sms_sender = new NamirasoftSMSSenderServer(REACT_APP_BASE_URL_SMS_SENDER, result.account.token_manager, result.notifier.onError);
            let telegram_sender = new NamirasoftTelegramSenderServer(REACT_APP_BASE_URL_TELEGRAM_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { notification_sender, email_sender, sms_sender, telegram_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={NotificationSenderRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={NotificationSenderRoutes.TopicList} element={<TopicListPage {...result} servers={servers} />} />
                            <Route path={NotificationSenderRoutes.TopicNew} element={<TopicEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={NotificationSenderRoutes.TopicView(":id")} element={<TopicViewPage {...result} servers={servers} />} />
                            <Route path={NotificationSenderRoutes.TopicCopy(":id")} element={<TopicEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={NotificationSenderRoutes.TopicEdit(":id")} element={<TopicEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={NotificationSenderRoutes.Send(null)} element={<SendPage {...result} servers={servers} />} />
                            <Route path={NotificationSenderRoutes.Send(":id")} element={<SendPage {...result} servers={servers} />} />

                            <Route path={NotificationSenderRoutes.SubscriberList} element={<SubscriberListPage {...result} servers={servers} />} />
                            <Route path={NotificationSenderRoutes.SubscriberNew} element={<SubscriberEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={NotificationSenderRoutes.SubscriberView(":id")} element={<SubscriberViewPage {...result} servers={servers} />} />
                            <Route path={NotificationSenderRoutes.SubscriberCopy(":id")} element={<SubscriberEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={NotificationSenderRoutes.SubscriberEdit(":id")} element={<SubscriberEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={NotificationSenderRoutes.SubscriberVerify(":subscriber_id")} element={<VerifySubscriberPage {...result} servers={servers} />} />

                            <Route path={NotificationSenderRoutes.SentTopicList} element={<SentTopicListPage {...result} servers={servers} />} />
                            <Route path={NotificationSenderRoutes.SentSubscriberList} element={<SentSubscriberListPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={NotificationSenderRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <NotificationSenderLayout {...props}>
                {props.children}
            </NotificationSenderLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;